import firebase from 'firebase';
import { allprojectListActions } from './Reducers/AllProjectsReducer';
import { eventListActions } from './Reducers/EventListReducer';
import { oneprojectActions } from './Reducers/OneProjectReducer';

export const getProjectsToEventSlider = async (eventlistDispatch, prevList) => {
    return firebase
        .firestore()
        .collection('projects')
        .limit(9)
        .onSnapshot({
            next: (snapshot) => {
                let addDocs = snapshot.docs.map(e => {
                    return {
                        id: e.id,
                        ...e.data()
                    };
                });

                eventlistDispatch({
                    type: eventListActions.SET_EVENTLIST,
                    projectList: addDocs,
                });
            }
        });
};

export const getAllProjects = async (allprojectsDispatch, prevList, projectyear) => {
    //console.log('abc');
    return firebase
        .firestore()
        .collection('projects')
        .where('projectyear', '==', projectyear)
        .onSnapshot({
            next: (snapshot) => {
                let addDocs = snapshot.docs.map(e => {
                    return {
                        id: e.id,
                        ...e.data()
                    };
                });
                console.log(addDocs);
                allprojectsDispatch({
                    type: allprojectListActions.SET_ALLPROJECTS,
                    allprojectList: addDocs,
                });
            }

        });
};

export const getOneProject = async (oneprojectDispatch, id) => {
    console.log(id);
    firebase.firestore().collection('projects').doc(id).onSnapshot({
        next: (snapshot) => {
            let project = snapshot.data();
            console.log(project);
            oneprojectDispatch({
                type: oneprojectActions.SET_ONEPROJECT,
                oneproject: project,
            });
        }
    });

    //.then((doc) => {
    //     if (doc.exists) {
    //         oneprojectDispatch({
    //             type: oneprojectActions.SET_ONEPROJECT,
    //             oneproject: doc.data(),
    //         });
    //     } else {
    //         // doc.data() will be undefined in this case
    //         console.log('No such document!');
    //     }
    // }).catch((error) => {
    //     console.log('Error getting document:', error);
    // });

};

